import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { LanguageService } from 'vhobjects-service/src/services';
import { ChooseIconComponent } from 'vhobjects-service';
import { FunctionService} from 'vhobjects-service/src/services';
import { AtwFlipBookAdmin } from 'vhobjects-admin';

@Component({
  selector: 'atw-flip-book-config',
  templateUrl: './flip-book-config.component.html',
  styleUrls: ['./flip-book-config.component.scss']
})
export class AtwFlipBookConfig implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() type: any; // xem đang ở page hay admin
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database

  currentViewAll: any = {};
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  id_subproject: any;
  resolution = null;
  style_fields = [
    {
      title: "vi_tri_hinh_anh",
      index: 1,
      isDrop: false
    },
    {
      title: "bo_tron",
      index: 2,
      isDrop: false
    }
  ];

  constructor(
    public functionService: FunctionService,
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private vhEventMediator: VhEventMediator,
    private matdialog: MatDialog,
    public languageService: LanguageService,  
    private nzModalService: NzModalService,
  ) { }

  ngOnInit(): void {
  }

  /**
   * Hàm mở modal chứa danh sách hình ảnh
   * - Để thay đổi thứ tự hình ảnh
   * - Để thêm hình ảnh
   * - Để xoá hình ảnh
   * - Để chuyển ảnh lên server
   */
  openModalEditImages() {
    const modal: NzModalRef = this.nzModalService.create({
      nzTitle: this.languageService.translate('danh_sach_hinh_anh'),
      nzWidth: '90%',
      nzContent: AtwFlipBookAdmin,
      nzComponentParams: {
        objectChoosing: this.objectChoosing,
        type: 'page',
        device: this.device,
        staticdata: this.staticdata
      },
      nzFooter: null,
    });
    modal.afterClose.subscribe(result => {
    });
  }

  /**
   * Hàm xử lý thay đổi vị trí cụm nút theo chiều dọc
   * @param event 
   */
  handleSetPositionControls(event) {
    if (event == 0 || event == 100) {
      this.config.controls.translate_y = event;
    } else {
      this.config.controls.translate_y = 50;
    }
    this.updateClassAndConfig()
  }

  /**
   * Hàm mở bảng chọn icon
   * @param item 
   */
  openDialogChooseIcon(eleName) {
    const dialogRef = this.matdialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.config.icon[eleName] = result.icon;
        this.updateConfig();
      }
    });
  }

  /**
   * Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      });
  }

  /**
   * Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_config']: this.config,
    });
  }

  updateClassAndConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
        [this.device + '_class']: this.class,
      });
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata });
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
  };
  openMapSub: { [name: string]: boolean } = { menu1: true, menu2: false };
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['image']['width'] = event.width + 'px';
    if (event.height) this.class['image']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  /** Xử lí lưu vị trí ảnh
   * -> xử lí dữ liệu bóng -> css:  object-position: `x y`
   */
  handleSetPositionImage() {
    this.class['flip-book__page-img']['object-position'] = `-${this.config.image.object_x}px -${this.config.image.object_y}px`;
    this.updateClassAndConfig();
  }

  //Hàm xử lý scale
  scale() {
    this.class['flip-book__page-img']['transform'] = `scale(${this.config.image.transfrom_scale})`;
    this.updateClassAndConfig();
  }
}
